import { render, staticRenderFns } from "./PersonalPropertiesDetailModal.vue?vue&type=template&id=cd6a84b8"
import script from "./PersonalPropertiesDetailModal.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertiesDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertiesDetailModal.vue?vue&type=style&index=0&id=cd6a84b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports